import { render, staticRenderFns } from "./GsCalendar.vue?vue&type=template&id=368c6f5a"
import script from "./GsCalendar.vue?vue&type=script&lang=js"
export * from "./GsCalendar.vue?vue&type=script&lang=js"
import style0 from "./GsCalendar.vue?vue&type=style&index=0&id=368c6f5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports